import { render, staticRenderFns } from "./distribute.vue?vue&type=template&id=9f385390&scoped=true"
import script from "./distribute.vue?vue&type=script&lang=ts"
export * from "./distribute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f385390",
  null
  
)

export default component.exports